import * as firebase from 'firebase';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { RouteComponentProps } from 'react-router';
import { BrowserRouter, Route, Switch } from 'react-router-dom'; 
import { getAjaxhelper } from './utils/CoreAjaxHelper';
import { HotelApplication, defaultSetting } from './HotelApplication';
import { SecurityData } from './shared';
import { updateLanguageWindow } from './utils/master-data-adapter';

export function bootStrapHotelAppOriginal(user: any, firebaseApp: firebase.app.App, realtimeDb: firebase.database.Database): any {
    console.log('Start app', new Date());
    /*
    getAjaxhelper().get('/dynamics/rest-api/system/current-login-info.svc')
        .then((d: any) => {
            */
    let targetDom: HTMLElement = document.getElementById('root') as HTMLElement;
    // console.log("user", d);
    ReactDOM.render(
        <BrowserRouter>
            <Switch>
                <Route
                    render={(props: RouteComponentProps<any>) => {
                        return <HotelApplication userLogin={user} history={props.history} firebaseApp={firebaseApp} realtimeDb={realtimeDb} currentAppPath={props.history.location.pathname + ''} />;
                    }}
                />
            </Switch>
        </BrowserRouter>
        ,
        targetDom);
    /*
})
.catch(exc => {
// alert('Error membaca login, error: ' + exc.message);
});
*/
}

/*
export function renderCheckoutPanel() {
    let targetDom: HTMLElement = document.getElementById('root') as HTMLElement;
    ReactDOM.render(
        <BookingCheckout />
        ,
        targetDom
    );
}
*/
export function bootStrapHotelApp(firebaseConfig: any) {
    window['getAjaxhelper'] = getAjaxhelper;
    let firebaseApp: firebase.app.App = null!;
    if (!firebase.apps || firebase.apps.length === 0) {
        if (!firebaseConfig) {
            alert('Firebase config not found in application. please report this problem to your admin');
        }
        firebaseApp = firebase.initializeApp(firebaseConfig);
    } else {
        firebaseApp = firebase.apps[0];
    }
    window['firebaseApp'] = firebaseApp;
    const realtimeDB = firebaseApp.database();
    let called = false;
    const unSubscribe = firebaseApp.auth().onAuthStateChanged((user) => {
        if (called) {
            return;
        }
        if (user) {
            console.log(user);
            called = true;
            let usr: SecurityData.ApplicationUser = {
                email: user.email!,
                uuid: user.uid,
                image_url: user.photoURL!,
                realName: user.displayName!
            };
            /*
            if (window['appType'] && window['appType'] === "checkout") {
                renderCheckoutPanel();
            } else {
                */
            let def = defaultSetting[window.location.hostname];
            let langCode: string = "ENG";
            if (def) {
                langCode = def.lang;
            }
            updateLanguageWindow(langCode).then(
                () => {  
                    bootStrapHotelAppOriginal(usr, firebaseApp, realtimeDB);
                    unSubscribe();
                }
            );
            // }
        } else {
            console.error('user null. berarti login di sini');
            firebaseApp.auth().signInAnonymously()
                .then(d => {
                    console.log('User data: ', d);
                }).catch(exc => {
                    console.error('Gagal login, error: ', exc);
                });
        }
    });
} 


// WEBPACK FOOTER //
// ./src/boot-app.tsx